import httpService, { type HttpRequestScope } from "./httpService";

export type ProfileConfigValue = string | number | boolean;

export type UserSettingsMap = Record<string, ProfileConfigValue>;

export interface ProfileConfigData {
  [key: string]: ProfileConfigValue | UserSettingsMap;
}

export interface ProfileConfig {
  id: number;
  userId: string;
  ibkrAccountId: string | null;
  data: ProfileConfigData | null;
  createdAtUtc: string;
  updatedAtUtc: string;
}

export interface ProfileConfigRequestOptions {
  requestScope?: Exclude<HttpRequestScope, "actor">;
}

const profileConfigService = {
  getUserConfig: async (
    options?: ProfileConfigRequestOptions
  ): Promise<ProfileConfig | null> => {
    try {
      const response = await httpService.get<ProfileConfig>(
        "/v2/profile/configs",
        options
      );
      return response.data;
    } catch (error: unknown) {
      if (
        error &&
        typeof error === "object" &&
        "response" in error &&
        (error as { response?: { status?: number } }).response?.status === 404
      ) {
        return null;
      }
      throw error;
    }
  },

  /** Merges key-value pairs into data.userSettings. Body is flat -- no wrapper. */
  patchUserSettings: async (settings: UserSettingsMap): Promise<ProfileConfig> => {
    const response = await httpService.patch<{ configuration: ProfileConfig }>("/v2/profile/configs", settings);
    return response.data.configuration;
  },
};

export default profileConfigService;
